function setPreferredVendors(state, preferredVendors) {
	state.preferredVendors = preferredVendors;
}

function setCarrierVendors(state, carrierVendors) {
	state.carrierVendors = {};
	for (let c of carrierVendors) {
		state.carrierVendors[c.id] = c;
	}
}

function set(state, fn) {
	if (fn)
		fn(state);
}

function setErrors(state, { errors, id }) {
	if (!errors) return;

	state.errors.code = errors.invalidCode || false;
	state.errors.description = errors.invalidDescription || false;
	state.errors.id = id ? id : '';
}

function clearErrors(state) {
	state.errors.code = false;
	state.errors.description = false;
	state.errors.id = '';
}

export default {
	setPreferredVendors,
	setCarrierVendors,
	set,
	setErrors,
	clearErrors
};